module.exports = __webpack_public_path__ + "static/media/Porto.00e8dddc.jpg";